import { styled } from "~/common/mui";

const SpacerRoot = styled("hr", {
  shouldForwardProp: (prop) => prop !== "isThick",
})<{ isThick?: boolean }>(({ theme, isThick }) => ({
  border: "none",
  borderTop: isThick
    ? `3px solid ${theme.palette.divider}`
    : `1px solid ${theme.palette.divider}`,
}));

interface SpacerProps extends Omit<JSX.IntrinsicElements["hr"], "children"> {
  isThick?: boolean;
}

const Spacer = ({ className, isThick, ...rest }: SpacerProps) => {
  return <SpacerRoot isThick={isThick} className={className} {...rest} />;
};

export default Spacer;
